import { ROUTES, ROUTE_QUERY } from 'types/navigation';
import { NavigationRoutes } from 'hooks/navigation/useNavigation';
import { openInNewTab } from 'features/communication-bridge/openInNewTab';

import { customEventFactory } from './events';

export const navigationHubEvent = () =>
	customEventFactory<{
		navigate?: (input: { routes: NavigationRoutes }) => string;
		replace?: (input: { routes: NavigationRoutes }) => string;
	}>('navigation-hub');

export function openNewTabSubscriptionPage(openUpgrade?: boolean) {
	if (openUpgrade) openInNewTab(`${ROUTES.AccountUMSubscription}?${ROUTE_QUERY.Upgrade}=true`);
	else openInNewTab(`${ROUTES.AccountUMSubscription}`);
}
